import { useTranslation } from "react-i18next";

import "./style.less";

const FooterBottom = () => {
  const { t } = useTranslation(["footer"]);
  return (
    <div className="footer-bottom__content">
      <div className="content__first">
        {t("copyright")} |{" "}
        <a
          href="https://help.shopee.com.my/portal/13/article/77225?previousPage=other%20articles "
          target="_blank"
          rel="noreferrer"
        >
          {t("termsOfService")}
        </a>{" "}
        |{" "}
        <a
          href="https://help.shopee.com.my/portal/13/article/77218?previousPage=other%20articles"
          target="_blank"
          rel="noreferrer"
        >
          {t("privacyPolicy")}
        </a>
      </div>
      <p>{t("sppContact")}</p>
      <p>{t("seamoneyContact")}</p>
    </div>
  );
};

export default FooterBottom;
